/**
 * N79 (Alana): "ao filtrar e clicar em Voltar, os filtros devem ser mantidos".
 *
 * As telas de listagem guardavam os filtros em useState puro; ao navegar para o
 * detalhe a página desmonta e tudo se perdia. Este hook é o mesmo padrão que já
 * existia para o mês do calendário (useCalendarioNavigation): sessionStorage,
 * lido no initializer e gravado a cada mudança, tolerante a storage indisponível.
 *
 * sessionStorage (e não localStorage) de propósito: os filtros valem para a
 * sessão de trabalho e somem quando o navegador fecha.
 */
import { useEffect, useState } from 'react';

export function usePersistedState<T>(key: string, initial: T | (() => T)) {
  const [value, setValue] = useState<T>(() => {
    try {
      const saved = sessionStorage.getItem(key);
      if (saved !== null) return JSON.parse(saved) as T;
    } catch { /* storage indisponível ou JSON inválido → usa o inicial */ }
    return typeof initial === 'function' ? (initial as () => T)() : initial;
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch { /* noop */ }
  }, [key, value]);

  return [value, setValue] as const;
}
